import React from "react";
import FacFnCopyXLS from "./FacFnCopyXLS";
import LibToast from "../../lib/LibToast";
import FnDownloadPDF from "./FnDownloadPDF";

const FacItemCmdTable = {
  Add: (onAdd) => {
    return {
      item: <> <i className="fa fa-plus m5R fIconBig "/> Agregar</>,
      fn: onAdd
    }
  },
  Separador: () => {
    return "sep"
  },
  CopyXls: (listaItemsFiltro, listaInclude) => {
    return {
      item: <> <i className="fa fa-file-excel-o m5R fIconBig"/> Copiar </>,
      fn: () => {
        
        FacFnCopyXLS(listaItemsFiltro, listaInclude);
        LibToast.info("Copiado")
      }
    };
  },
  PDFBasico: (listaItemsFiltro, numTotal, listaInclude, titulo) => {
    return {
      item: <> <i className="fa fa-download m5R fIconBig"/> PDF Básico </>,
      fn: () => {
        const subtitulo = `${listaItemsFiltro.length}/${numTotal} registros`
        FnDownloadPDF(listaItemsFiltro, listaInclude, titulo, subtitulo);
      }
    };
  }
};

export default FacItemCmdTable;